import { isIgnoredDomain } from '@unriddle/common';
import { ZodError, z } from 'zod';

const youtubeUrlPattern =
  /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})(?:[\?&][a-zA-Z0-9_-]+=[a-zA-Z0-9_-]*)*$/;

export const youtubeUrlSchema = z.string().regex(youtubeUrlPattern, {
  message:
    'Invalid YouTube URL. The URL must be in the format: https://www.youtube.com/watch?v=VIDEO_ID',
});
export const youtubeImportSchema = z.object({
  url: youtubeUrlSchema,
});

export const isYoutubeUrl = (url: string) => {
  try {
    const parsedUrl = new URL(url);
    youtubeUrlSchema.parse(parsedUrl.href);
    return true;
  } catch {
    return false;
  }
};

export const websiteUrlSchema = z
  .string()
  .url('Please enter a valid URL')
  .refine((url) => !isIgnoredDomain(url), {
    message: 'Due to copyright reasons we are not able process the website',
  });

export const websiteImportSchema = z.object({
  url: websiteUrlSchema.refine((url) => !isYoutubeUrl(url), {
    message:
      'YouTube URLs are not allowed here. You can import them in Video/Youtube URL',
  }),
});

export const validateWebsiteUrl = (url: string) => {
  try {
    websiteImportSchema.parse({ url });
    return { valid: true };
  } catch (error) {
    const defaultMessage = 'Please enter a valid URL';
    if (error instanceof ZodError) {
      return {
        message: error.issues[0]?.message || defaultMessage,
        valid: false,
      };
    }
    return { message: defaultMessage, valid: false };
  }
};
